import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchStaffList } from "../../../store/slices/staffSlice";
import { _vendorAdminRoutes } from "../../../utils/appRouter";
import { formatFileURL } from "../../../utils/helper/appHelpers";
import { apiUrl } from "../../../utils/endPoints/apiUrl";
import DeleteHandler from "../../../component/comman/DeleteHandler";
import { PageInfoHeader } from "../../../component/comman/PageInfoHeader";
import Pagination from "../../../comman/Pagination";   

const StaffListing = () => {
  const { staffListing, isLoading } = useSelector((state) => state.staff);
  const dispatch = useDispatch();

  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const limit = 10;

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      dispatch(fetchStaffList({ paginate: 1, limit, searchQ: search, page }));
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [search, page]);

  return (
    <section className="content mb-5">
      <div className="container-fluid">

        {/* HEADER */}
        <div className="row titlepad">
          <div className="col-md-12">
            <div className="mt-3 mb-3">
              <div className="dashbed-border-bottom"></div>
            </div>

            <div className="row align-items-end">
              <div className="col-sm-9">
                <h4>Staff</h4>

                <PageInfoHeader
                  page={page}
                  limit={limit}
                  total={staffListing?.count || 0}
                  label="list of staff"
                />

                <a
                  href={_vendorAdminRoutes.staff.add}
                  className="btn-md btn-primary d-inline-block"
                >
                  <i className="fa-solid fa-user-plus"></i> Add More
                </a>
              </div>

              <div className="col-md-3">
                <input
                  className="form-control searchinput"
                  type="text"
                  placeholder="Search Staff..."
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setPage(1);
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="mb-3">
              <div className="dashbed-border-bottom"></div>
            </div>
          </div>

          <div className="col-md-12">
            <div className="tab-content">
              <div className="tab-pane fade show active">

                <div className="row">

                  {!isLoading ?
                    staffListing?.rows?.length > 0 ?
                      staffListing.rows.map((item, index) => (
                        <div className="col-md-4" key={item._id}>
                          <div className="card package-section cc-section">
                            <div className="row">
                              <div className="col-4">
                                <div className="cc-image">
                                  <img src={formatFileURL(item?.profilePic)} alt="profile" />
                                </div>
                              </div>
                              <div className="col-8 pl-0">
                                <h5>{item?.userName}</h5>
                                <h6 className="my-1">
                                  {item?.staffInfo?.specialistServices
                                    .map(s => s.label)
                                    .join(", ")}
                                </h6>
                                <h6>{`${item?.dialCode} ${item?.mobileNo}`}</h6>
                                <span className="badge bad-status badge-success">{item?.status}</span>
                              </div>

                              <div className="col-md-12 mt-3">
                                <div className="border-top"></div>
                              </div>

                              <div className="col-md-12 d-flex justify-content-between mt-3">
                                <DeleteHandler
                                  heading="Confirm Staff Deletion"
                                  content="Are you sure you want to delete this staff?"
                                  apiUrl={apiUrl.staff.root}
                                  id={item?._id}
                                  showTriggerButton={true}
                                  onDelete={() =>
                                    dispatch(fetchStaffList({ paginate: 1, limit }))
                                  }
                                />

                                <a
                                  href={_vendorAdminRoutes.staff.edit(item?._id)}
                                  className="btn-md card-btn btn-primary"
                                >
                                  <i className="fa fa-eye"></i> View/Edit
                                </a>

                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                      :
                      <p className="text-center w-100">DATA NOT FOUND</p>
                    :
                    <p className="text-center w-100">LOADING...</p>
                  }

                  <div className="col-md-12 mt-4">
                    <Pagination
                      page={page}
                      limit={limit}
                      total={staffListing?.count || 0}
                      onPageChange={(newPage) => setPage(newPage)}
                      showAlways={true}
                    />
                  </div>

                </div>

              </div>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default StaffListing;
